import Vue from 'vue'
import Vuex from 'vuex'

import { SET_CURRENT_LANG, SET_INNER_WIDTH } from './mutation-types'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    innerWidth: window.innerWidth,
    currentLang: 'en',
  },
  mutations: {
    [SET_INNER_WIDTH](state, payload) {
      state.innerWidth = payload
    },
    [SET_CURRENT_LANG](state, payload) {
      state.currentLang = payload
    },
  },
  actions: {
    onResize({ commit }) {
      commit('SET_INNER_WIDTH', window.innerWidth)
    },
    changeLanguage({ commit }, payload) {
      commit('SET_CURRENT_LANG', payload)
    },
  },
  modules: {},
})
